import React, {useContext} from 'react';
import {Flex, Box} from 'reflexbox';
import TimeoutSvg from "./TimeoutSvg.js";
import './TimeoutPopup.scss';
import {StoreContext} from '../../helpers/StoreContext';

export default (props)=> {
  const displayStore = useContext(StoreContext).displayStore;

  const rootStore = useContext(StoreContext);
  const hotelStore = rootStore.hotelStore;

  return (<div className="timeoutPopup">
    <Flex>
      <Box className="left" width={[1,1,0.3]}><TimeoutSvg /></Box>
      <Box width={[1,1,0.7]}>
        <h1>Hallo, bist du noch da?</h1>
        <p>Deine Suchergebnisse sind unter Umständen nicht mehr aktuell.</p>
        <p>Bitte aktualisiere deine Angebote!</p>
        <div className="buttoncenter">
          <button
              className="button"
              onClick={
                (e)=> {
                  displayStore.setPopup(false);
                  hotelStore.updateHotel('all');
                }
              }
          >
            Angebote aktualisieren!
          </button>
        </div>

      </Box>
    </Flex>

  </div>)
}
